/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { TeamSettingAuthorizationResource } from './';
import {
    TeamSettingAuthorizationResourceFromJSON,
    TeamSettingAuthorizationResourceFromJSONTyped,
    TeamSettingAuthorizationResourceToJSON,
} from './';
import type { TeamSettingInvitationLinkStateResource } from './';
import {
    TeamSettingInvitationLinkStateResourceFromJSON,
    TeamSettingInvitationLinkStateResourceFromJSONTyped,
    TeamSettingInvitationLinkStateResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientTeamSettingsResource
 */
export interface ClientTeamSettingsResource {
    /**
     * 
     * @type {TeamSettingAuthorizationResource}
     * @memberof ClientTeamSettingsResource
     */
    membersListAccessAuthorization: TeamSettingAuthorizationResource;
    /**
     * 
     * @type {TeamSettingAuthorizationResource}
     * @memberof ClientTeamSettingsResource
     */
    invitationSendingAuthorization: TeamSettingAuthorizationResource;
    /**
     * 
     * @type {TeamSettingInvitationLinkStateResource}
     * @memberof ClientTeamSettingsResource
     */
    invitationLinkState: TeamSettingInvitationLinkStateResource;
}

/**
 * Check if a given object implements the ClientTeamSettingsResource interface.
 */
export function instanceOfClientTeamSettingsResource(value: object): value is ClientTeamSettingsResource {
    if (!('membersListAccessAuthorization' in value) || value['membersListAccessAuthorization'] === undefined) return false;
    if (!('invitationSendingAuthorization' in value) || value['invitationSendingAuthorization'] === undefined) return false;
    if (!('invitationLinkState' in value) || value['invitationLinkState'] === undefined) return false;
    return true;
}

export function ClientTeamSettingsResourceFromJSON(json: any): ClientTeamSettingsResource {
    return ClientTeamSettingsResourceFromJSONTyped(json, false);
}

export function ClientTeamSettingsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientTeamSettingsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'membersListAccessAuthorization': TeamSettingAuthorizationResourceFromJSON(json['membersListAccessAuthorization']),
        'invitationSendingAuthorization': TeamSettingAuthorizationResourceFromJSON(json['invitationSendingAuthorization']),
        'invitationLinkState': TeamSettingInvitationLinkStateResourceFromJSON(json['invitationLinkState']),
    };
}

export function ClientTeamSettingsResourceToJSON(value?: ClientTeamSettingsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'membersListAccessAuthorization': TeamSettingAuthorizationResourceToJSON(value['membersListAccessAuthorization']),
        'invitationSendingAuthorization': TeamSettingAuthorizationResourceToJSON(value['invitationSendingAuthorization']),
        'invitationLinkState': TeamSettingInvitationLinkStateResourceToJSON(value['invitationLinkState']),
    };
}

